import { observable, action, reaction } from 'mobx';
import { createContext } from 'react';

import { getAuth, getUserinfo, logOut,recordChangeUser } from '../service/user';
class UserAuthStore {
  @observable authdata: any = null;
  @observable userInfo: any = null;
  @observable appId: string = '';
  @action.bound
  getAuth() {
    getUserinfo().then((res: any) => {
      this.userInfo = res.data;
      this.appId=res.data.lastAppid||'';
    });

    getAuth()
      .then((res: any) => {
        this.authdata = res.data;
      })
      .catch((e) => {
        this.authdata = {};
      });
  }
  changRecord( appid :string){
    if(appid&&this.appId !== appid){
      this.appId=appid;
      recordChangeUser({appId:appid})
    }

  }
  logOut() {
    logOut().then((res: any) => {
      document.cookie =
        'returnUrl=' + window.location.origin + ';domain=xdf.cn;path=/';
      window.location.href = res.message;
    });
  }
}

const userAuthStore = new UserAuthStore();
export default createContext(userAuthStore);
